<template>
  <div class="Admin">
    <el-row>
      <el-col :span="14" class="order-dashboard">
        <!-- 注文状況 -->
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <el-row>
              <el-col :span="12">注文状況</el-col>
              <el-col :span="12" class="goToHomeBtn cursorPointer all-tab">
                <div @click="_goToOrderListScreen()">
                  すべての注文
                  <el-button
                    type="text"
                    id="arrow-right"
                    icon="el-icon-arrow-right"
                  ></el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-row class="rowStyle">
            <el-col :span="6">
              <div class="cursorPointer">
                <span class="orderStatusText">新規注文</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="cursorPointer">
                <span class="orderStatusText">レイアウト作成中</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="cursorPointer">
                <span class="orderStatusText">レイアウト調整中</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="cursorPointer">
                <span class="orderStatusText">注文確定</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="rowStyle">
            <el-col :span="6">
              <div class="cursorPointer">
                <el-button
                  id="statusBtn"
                  type="text"
                  @click="_goToOrderListScreen('PROCESSING')"
                >
                  {{ ORDERS_PROCESSING }}
                </el-button>件
              </div>
            </el-col>
            <el-col :span="6">
              <div class="cursorPointer">
                <el-button
                  id="statusBtn"
                  type="text"
                  @click="_goToOrderListScreen('PROCESSING_CREATING_LAYOUT')"
                >
                  {{ ORDERS_PROCESSING_CREATING_LAYOUT }}
                </el-button>件
              </div>
            </el-col>
            <el-col :span="6">
              <div class="cursorPointer">
                <el-button
                  id="statusBtn"
                  type="text"
                  @click="_goToOrderListScreen('REVISING_LAYOUT')"
                >
                  {{ ORDERS_REVISING_LAYOUT }}
                </el-button>件
              </div>
            </el-col>
            <el-col :span="6">
              <div class="cursorPointer">
                <el-button
                  id="statusBtn"
                  type="text"
                  @click="_goToOrderListScreen('CONFIRMED')"
                >
                  {{ ORDERS_CONFIRMED }}
                </el-button>件
              </div>
            </el-col>
          </el-row>
        </el-card>
        <!-- 新規注文 -->
        <p id="order-create">
          <span class="orderRequest">新規注文</span>
        </p>
        <el-table
          :data="NEW_ORDER"
          v-loading="isLoading"
          id="order-table"
          @row-click="onClickDetail($event)"
        >
          <el-table-column prop label="注文番号">
            <template slot-scope="scope">{{ scope.row.orderNumber }}</template>
          </el-table-column>
          <el-table-column prop label="受注日">
            <template slot-scope="scope">
              {{ scope.row.orderedAt | humanize.date }}
            </template>
          </el-table-column>
          <el-table-column prop label="得意先名">
            <template slot-scope="scope" v-if="scope.row.client.clientGroup">{{
              scope.row.client.clientGroup.name
            }}</template>
          </el-table-column>
          <el-table-column prop label="お客様名" class-name="lastCol">
            <template slot-scope="scope" v-if="scope.row.customer">{{
              scope.row.customer.name
            }}</template>
          </el-table-column>
        </el-table>
        <!-- 注文キャンセル依頼 -->
        <p id="order-create">
          <span class="orderRequest">注文キャンセル依頼</span>
        </p>
        <el-table
          v-loading="isLoading"
          :data="ORDERS_CANCEL_REQUEST"
          id="order-table"
          @row-click="onClickDetail($event)"
        >
          <el-table-column prop label="注文番号">
            <template slot-scope="scope">{{ scope.row.orderNumber }}</template>
          </el-table-column>
          <el-table-column prop label="受注日">
            <template slot-scope="scope">
              {{ scope.row.orderedAt | humanize.date }}
            </template>
          </el-table-column>
          <el-table-column prop label="得意先名">
            <template slot-scope="scope" v-if="scope.row.client.clientGroup">{{
              scope.row.client.clientGroup.name
            }}</template>
          </el-table-column>
          <el-table-column prop label="お客様名" class-name="lastCol">
            <template slot-scope="scope" v-if="scope.row.customer">{{
              scope.row.customer.name
            }}</template>
          </el-table-column>
        </el-table>
      </el-col>
      <!-- 新規メッセージ -->
      <el-col :span="9" class="messages">
        <el-card class="box-card" shadow="never" id="rightCard">
          <div slot="header" class="clearfix">
            <span>新規メッセージ</span>
          </div>
          <div class="messageCard">
            <div
              v-for="(val, index) in latestMessages"
              :key="index"
              class="cursorPointer hoverColor"
            >
              <div
                class="messageStyle"
                @click="gotoMessageDetail(val.order.id)"
              >
                <el-row>
                  <el-col :span="12" v-if="val.from">{{
                    val.from.name
                  }}</el-col>
                  <el-col :span="12" id="createdDate">{{
                    val.createdAt | humanize.date
                  }}</el-col>
                </el-row>
                <div class="messageBody">
                  <span v-if="val.body.length > 50"
                    >{{ val.body.substring(0, 50) }}...</span
                  >
                  <span v-else>{{ val.body }}</span>
                </div>
              </div>
              <div class="footerRight" @click="gotoMessageDetail(val.order.id)">
                <el-button
                  v-for="(item, index) in val.images"
                  type="text"
                  :key="index"
                  @click="viewImage(item)"
                >
                  <img :src="item" alt width="80" class="attachedImage" />
                </el-button>
              </div>
              <hr class="message-line" />
            </div>
            <el-dialog
              :visible.sync="dialogVisible"
              :modal="false"
              id="imageDialog"
            >
              <button class="imageCloseBtn">
                <div class="close" @click="dialogVisible = false">✕</div>
                <div>
                  <img
                    :src="imgDetail"
                    alt
                    class="dialog-image"
                    v-if="!isLoading"
                  />
                </div>
              </button>
            </el-dialog>
            <div class="v-modal" v-if="dialogVisible"></div>
            <infinite-loading @infinite="infiniteHandler">
              <span slot="no-more"></span>
              <span slot="no-results"></span>
            </infinite-loading>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import UsecaseFactory from "@/usecases/usecase.factory.js";
import OrderUsecase from "@/usecases/order.usecase";
import InfiniteLoading from "vue-infinite-loading";
import { apiErrorHandler } from "@/services/apiErrorHandler";

const messageUsecase = UsecaseFactory.create("message");

export default {
  components: {
    InfiniteLoading,
  },
  data () {
    return {
      orderUsecase: new OrderUsecase(),
      ORDERS_PROCESSING: 0,
      ORDERS_PROCESSING_CREATING_LAYOUT: 0,
      ORDERS_REVISING_LAYOUT: 0,
      ORDERS_CONFIRMED: 0,
      ORDERS_CANCEL_REQUEST: [],
      NEW_ORDER: [],
      latestMessages: [],
      dialogVisible: false,
      imgDetail: false,
      isLoading: false,
      isViewImage: false,
      page: 1,
      count: 10,
      q: {},
      isQuery: false,
      startCursor: "start",
      endCursor: "",
      hasNextPage: null,
      hasPreviousPage: null,
    };
  },
  async created () {
    const currentUser = this.$store.state.user;
    if (currentUser && currentUser.sub) {
      this.isLoading = true;
      this.getOrderByStatus();
    }
  },
  methods: {
    // infinite scroll handler
    async infiniteHandler ($state) {
      try {
        // get messages params
        const messagesParams = this.getMessagesParams();

        // get messages info
        const result = await messageUsecase.getLatestMessages(messagesParams);

        // set up data
        this.endCursor = result.pageInfo.endCursor;
        this.hasNextPage = result.pageInfo.hasNextPage;
        this.hasPreviousPage = result.pageInfo.hasPreviousPage;
        result.edges.map(res => {
          this.latestMessages.push(res.node);
        });

        if (!this.hasNextPage) $state.complete();
        else {
          this.startCursor = result.pageInfo.startCursor;
          this.page += 1;
          $state.loaded();
        }
      } catch (err) {
        apiErrorHandler(this, err);
      } finally {
        $state.complete();
      }
    },
    // get messages params that parse to api
    getMessagesParams () {
      return {
        first: this.count,
        after: this.endCursor,
      };
    },
    // get orders by status
    async getOrderByStatus () {
      // get orders by status PROCESSING
      try {
        this.ORDERS_PROCESSING = await this.orderUsecase.getOrderCount({
          status: "PROCESSING",
        });
        this.ORDERS_PROCESSING_CREATING_LAYOUT = await this.orderUsecase.getOrderCount({
          status: "PROCESSING_CREATING_LAYOUT",
        });
        // get orders by status REVISING_LAYOUT
        this.ORDERS_REVISING_LAYOUT = await this.orderUsecase.getOrderCount({
          status: "REVISING_LAYOUT",
        });
        // get orders by status CONFIRMED
        this.ORDERS_CONFIRMED = await this.orderUsecase.getOrderCount({
          status: "CONFIRMED",
        });
        // get orders by status CANCEL_REQUEST
        const cancelRequest = await this.orderUsecase.getOrders({
          q: { status: "CANCEL_REQUEST" },
        });
        this.ORDERS_CANCEL_REQUEST = cancelRequest.orders;
        // get new order for today with processing status
        var date = new Date();
        const startTime = date.setHours(0, 0, 0, 0) / 1000;
        const endTime = date.setHours(23, 59, 59, 999) / 1000;
        const newOrder = await this.orderUsecase.getOrders({
          q: {
            status: "PROCESSING",
            orderedAtStart: startTime,
            orderedAtEnd: endTime,
          },
        });
        this.NEW_ORDER = newOrder.orders;
        if (this.NEW_ORDER.length > 10) {
          const newOrder = document.querySelectorAll(
            ".el-table__body-wrapper"
          )[0];
          newOrder.style.height = "500px";
          newOrder.style.overflowY = "auto";
        }
        if (this.ORDERS_CANCEL_REQUEST.length > 10) {
          const cancelOrder = document.querySelectorAll(
            ".el-table__body-wrapper"
          )[1];
          if (cancelOrder && cancelOrder.style && cancelOrder.style.height) {
            cancelOrder.style.height = "500px";
          }
          if (cancelOrder && cancelOrder.style && cancelOrder.style.overflowY) {
            cancelOrder.style.overflowY = "auto";
          }
        }
      } catch (err) {
        apiErrorHandler(this, err);
      } finally {
        this.isLoading = false;
      }
    },
    // go to order screen with parameter
    _goToOrderListScreen (status = "") {
      const { $router } = this;
      $router.push(`/admin/home?status=${status}`);
    },
    // go to message detail screen
    gotoMessageDetail (orderID) {
      if (this.isViewImage) {
        this.isViewImage = false;
        return false;
      }
      const { $router } = this;
      $router.push(`/admin/orders/${orderID}/messages`);
      window.scrollTo(0, 0);
    },
    // got to order detail screen
    onClickDetail (message) {
      const id = message.id;
      const { $router } = this;
      this.$store.commit("orderForm/setOrderId", id);
      $router.push(`/admin/orders/${id}`);
    },
    // view image from message list
    async viewImage (item) {
      this.isViewImage = true;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
        this.dialogVisible = true;
        this.imgDetail = item;
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.Admin {
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.Admin .cardBody {
  display: block;
  height: 200px;
  overflow: scroll;
}

.Admin .messageCard {
  height: 600px;
  display: block;
  overflow-y: scroll;
}

.Admin .attachedImage {
  padding-left: 0.5rem;
}

.Admin .footerRight {
  text-align: right;
  margin-top: 1rem;
}

.Admin .v-modal {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: black;
}

.Admin .orderRequest {
  padding-left: 1rem;
  line-height: 3;
}

.Admin .all-tab {
  text-align: right;
}

::v-deep .el-card {
  border: 1px solid $--border-color-light;
}
::v-deep .el-card__header {
  background: $background-gray-deep;
  padding: 10px 20px !important;
}
::v-deep .el-row .el-button {
  font-size: 41px;
  color: $text-light;
  font-weight: bold;
  text-decoration: underline;
}

::v-deep td {
  border-left: 0.5px solid $--border-color-lighter !important;
  margin-left: 0.3rem !important;
}
::v-deep th {
  color: $text-base !important;
  background: $background-gray-base !important;
  border-left: 0.5px solid $--border-color-lighter !important;
}

::v-deep .el-table th.is-leaf {
  text-align: center !important;
}
::v-deep .el-table__header-wrapper table {
  width: 100% !important;
}

::v-deep th {
  text-align: center !important;
  color: $text-base !important;
  background: $background-gray-deep !important;
  border-left: 1px solid $--border-color-lighter !important;
}
::v-deep td {
  border-left: 1px solid $--border-color-lighter !important;
}

::v-deep .el-dialog__header {
  padding: 0px 0px 0px 0px !important;
}
::v-deep .el-dialog {
  -webkit-box-shadow: none;
  box-shadow: none;
}
::v-deep .el-dialog {
// .el-pager li {
  background: none !important;
}
::v-deep .el-dialog__headerbtn {
  font-size: 0px;
}
::v-deep .el-table--border th.gutter:last-of-type :first-child {
  background: $background-gray-deep !important;
  border-left: 1px solid $--border-color-lighter !important;
}
::v-deep .el-table__body {
// .el-table__footer,
// .el-table__header {
  table-layout: fixed !important;
}
::v-deep .el-table__footer-wrapper {
// .el-table__header-wrapper {
  background: $background-gray-base !important;
}
::v-deep .el-table__body-wrapper {
  cursor: pointer !important;
}
.order-dashboard {
  margin-left: 3%;
  margin-bottom: 2%;
}
#arrow-right {
  padding: 0px;
}
#order-create {
  background: $background-gray-deep !important;
  width: 100%;
  height: 49px;
}
#order-table {
  width: 100%;
  border: 1px solid $--border-color-light;
}
.messages {
  padding-left: 2rem;
}
.message-name {
  line-height: 3;
}
.message-date {
  line-height: 3;
}
.message-line {
  border: 0.5px solid $--border-color-lighter;
  widows: 100%;
  margin-top: 1rem;
}
// #message .el-card__body {
//   padding-top: 0px !important;
// }
.message-text {
  line-height: 1;
}
.order-message {
  margin-left: 10%;
  line-height: 2;
  text-decoration: underline;
}
.Admin ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.Admin ::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: $background-gray-deep;
  height: 100px;
}
.Admin .goToHomeBtn .el-button {
  font-size: 15px !important;
}
.cardBody span {
  word-spacing: 10px;
}
#statusBtn {
  padding-right: 1rem;
}
#rightCard {
  margin-right: 5rem;
}
.box-card {
  margin-top: 1rem;
}
#rightCardBtn {
  padding: 0px;
  float: right;
}
.rowStyle {
  margin-left: 5%;
}
.goToHomeBtn {
  float: right;
  cursor: pointer;
}
.orderStatusText {
  display: block;
}
.orange-color-change {
  color: $orange-light !important;
}
.white-color-change {
  color: white !important;
}
.Admin .el-table__header-wrapper table {
  background: $background-gray-deep; // rgb(214, 213, 213);
}
#createdDate {
  text-align: right;
  font-size: 15px;
}
.messageBody {
  padding-top: 1rem;
}
.hoverColor:hover {
  background-color: $--background-color-base;
}
#rightCard {
  ::v-deep .el-card__body {
    padding: 0px !important;
  }
}
#rightCard .messageStyle {
  padding: 20px;
  margin-top: -0.5rem;
}
.Admin .dialog-image {
  max-width: 90% !important;
  width: auto !important;
}
.imageCloseBtn {
  outline: 0;
  background: none;
  border: none;
  display: block;
  margin-left: auto !important;
  margin-right: auto !important;
}
.close {
  float: right;
  color: white;
  margin-top: -1.1rem;
}
</style>
